import { createContext, useContext } from "react";
import { AuthConfig } from "./config";

export const AuthConfigContext = createContext<AuthConfig | null>(null);

export function useAuthConfig(): AuthConfig {
  const config = useContext(AuthConfigContext);
  if (!config) throw new Error("useAuth must be used inside <AuthProvider>");
  return config;
}

/** Lets the API layer report auth outcomes the whole app must show. */
export interface AuthStatus {
  reportSessionEnded: () => void;
  reportForbidden: () => void;
}

const noop = () => undefined;
export const AuthStatusContext = createContext<AuthStatus>({ reportSessionEnded: noop, reportForbidden: noop });

export function useAuthStatus(): AuthStatus {
  return useContext(AuthStatusContext);
}
